module.exports = __webpack_public_path__ + "img/pure white holy night.bd1e01e2.png";